import { connect } from 'react-redux';
import {
  compose,
  setDisplayName,
  pure,
  lifecycle,
  withHandlers
} from 'recompose';
import { createSelector } from 'reselect';
import WidgetList from '../../views/WidgetList';
import { widgetGet, moveWidget } from '../../../actions';
import { selectStateWidgetList } from '../../../selectors';

export default compose(
  setDisplayName('WidgetListContainer'),
  connect(
    createSelector(selectStateWidgetList(), widgetList => ({
      widgetList
    })),
    {
      moveWidget,
      widgetGet
    }
  ),
  lifecycle({
    componentDidMount() {
      this.props.widgetGet(90);
    }
  }),
  withHandlers({
    onClickOption: props => (position, action) => {
      props.moveWidget(position, action);
    }
  }),
  pure
)(WidgetList);
